import { App as AppPlugin } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { CapacitorUpdater } from '@capgo/capacitor-updater';
import { useQuery } from '@tanstack/react-query';

type AppVersionInfo = {
  version: string | null;
  build: string | null;
  nativeVersion: string | null;
  buildNumber: string | null;
  bundleVersion: string | null;
  platform: string;
  isNative: boolean;
};

export const useAppVersion = () => {
  return useQuery({
    queryKey: ['app-version'],
    queryFn: async (): Promise<AppVersionInfo> => {
      const platform = Capacitor.getPlatform();
      const isNative = Capacitor.isNativePlatform();

      let version: string | null = null;
      let build: string | null = null;

      if (isNative) {
        try {
          const info = await AppPlugin.getInfo();
          version = info.version ?? null;
          build = info.build ?? null;
        } catch (err) {
          console.warn('[useAppVersion] App.getInfo failed', err);
        }
      }

      let bundleVersion: string | null = null;
      if (isNative) {
        try {
          const current = await CapacitorUpdater.current();
          bundleVersion = current.bundle.version ?? null;
        } catch (err) {
          console.warn('[useAppVersion] CapacitorUpdater.current failed', err);
        }
      }

      return {
        version,
        build,
        nativeVersion: version,
        buildNumber: build,
        bundleVersion,
        platform,
        isNative,
      };
    },
  });
};
